module.exports = __webpack_public_path__ + "img/b-pink-s@2x.c30c4253.png";